export default __webpack_public_path__ + "static/twk-lausanne-light-252fe82253d6fbd189e868bd7068d952.ttf";